import React, { Component } from "react";
import axios from "axios";
import { Grid, Row, Col } from "react-bootstrap";
import LoadingSpinner from "../../components/Input/LoadingSpinner";
import SweetAlert from "react-bootstrap-sweetalert";
import DatePicker from "react-date-picker";
import Select from "react-select";
import { convertToDropDown } from "../../components/Methods/Methods";
import HmacSHA256 from "crypto-js/hmac-sha256";
import moment from "moment";
class PrintoManifestKorrieri extends Component {
  constructor(props) {
    super(props);

    this.state = {
      CantaKodi: "",
      AgjensiaBurim: window.UserP.agencyId,
      PerdoruesId: "",
      IdProcesori: "",
      Data1: new Date(),
      username: window.UserP.username,
      loading: false,
      alert: null,
      txtAgjensi: true,
      posts: [{}],
      Agjensi: window.UserP.agencyId,
      Destinacioni: "",
      data2: [],
      Korrier: "",
      test: [],
    };
  }

  handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value.toUpperCase() });
  };

  onChangeFunc = (name) => (value) => {
    this.setState({
      [name]: value,
    });
  };

  handleChange = (value) => {
    this.setState({
      Data1: value,
    });
  };

  printfunction = (post) => {
    var windowName = "";
    var windowUrl = " ";
    var myWindow = window.open(
      windowUrl,
      windowName,
      "left=0,top=0,right=0,bottom=0 margin=0,0,0,0"
    );

    let test = this.state.posts;
    var test5 =
      "&nbsp" +
      // "<table >" +
      "<tr>" +
      "<th >" +
      "Agjensia/Korrieri : " +
      this.state.AgjensiaBurim +
      "<br>" +
      "Agjensia Destinacion : " +
      this.state.Destinacioni +
      "&nbsp" +
      "&nbsp" +
      "&nbsp" +
      "&nbsp" +
      "&nbsp" +
      "&nbsp" +
      "Data : " +
      this.state.Data1.toLocaleDateString() +
      "<br>" +
      "</th>" +
      "<br>" +
      "<br>" +
      "Manifest Korrieri" +
      "<br>" +
      "<font face='calibri'" +
      ">" +
      "<br>" +
      "&nbsp" +
      "&nbsp" +
      "<br>" +
      "<br>" +
      "<b>" +
      "   </tr>" +
      "<table border='1' >" +
      "<thead>" +
      "<tr>" +
      "<th class='cell'>" +
      "Nr" +
      "</th>" +
      "<th class='cell'>" +
      "Pod" +
      "</th>" +
      " <th class='cell'>" +
      "Derguesi" +
      "</th>" +
      "<th class='-cell'>" +
      "Marresi" +
      "</th>" +
      "<th class='-cell'>" +
      "K.Prod" +
      "</th>" +
      "<th class='-cell'>" +
      "Pesha" +
      "</th>" +
      "<th class='-cell'>" +
      "Menyre" +
      "</th>" +
      "<th class='-cell'>" +
      "Shtesa" +
      "</th>" +
      "<th class='-cell'>" +
      "Vlera" +
      "</th>" +
      "<th class='-cell'>" +
      "KPagesa" +
      "</th>" +
      "<th class='-cell'>" +
      "Mon." +
      "</th>" +
      "<th class='-cell'>" +
      "Verejtje" +
      "</th>" +
      "  </tr>" +
      "  </thead>" +
      "  <tbody>";

    for (var i = 0; i < test.length; i++) {
    
      test5 +=
        "<tr class='firstRow'>" +
        "<td class='Nr_POD:-cell'>" +
        i.toString() +
        "</td>" +
        "<td class='Nr_POD:-cell'>" +
        test[i].POD +
        "</td>" +
        " <td class='Derguesi:-cell'>" +
        test[i].Derguesi +
        "</td>" +
        " <td class='Marresi:-cell'>" +
        test[i].Marresi +
        "</td>" +
        " <td class='K.Prod:-cell'>" +
        test[i].KProd +
        "</td>" +
        " <td class='Pesha:-cell'>" +
        test[i].Pesha +
        "</td>" +
        " <td class='Menyre:-cell'>" +
        test[i].Menyra +
        "</td>" +
        " <td class='Shtesa:-cell'>" +
        test[i].Shtesa +
        "</td>" +
        " <td class='Vlera:-cell'>" +
        test[i].Vlera +
        "</td>" +
        " <td class='KPagesa:-cell'>" +
        test[i].KPagesa +
        "</td>" +
        " <td class='Mon.:-cell'>" +
        test[i].Monedha +
        "</td>" +
        " <td class='verejtje:-cell'>" +
        test[i].Vrejtje +
        "</td>" +
        "   </tr>" ;
    }

    test5 += "  </tbody></table></font>";

    myWindow.document.write(test5);

    myWindow.focus();
    myWindow.print();
  };

  hideAlert() {
  
    this.setState({
      alert: null,
    });
  }
  componentDidMount() {
    fetch(window.UserP.url + "POD/GetKodKorrieri", {
      method: "Post",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      body: JSON.stringify({
        Token: HmacSHA256(
          Math.round(new Date().getTime() / 1000).toString(),
          window.UserP.key
        ).toString(),
        username: window.UserP.username,
        Id: window.UserP.agency,
      }),
    })
      .then((res) => res.json())
      .then((data) => this.setState({ data2: data }));
  }

  showErrors() {
    const getAlert = () => (
      <SweetAlert
        warning
        title="Mesazh"
        closeOnClickOutside={false}
        onConfirm={() => this.hideAlert()}
        onCancel={() => this.hideAlert()}
        showCancel
      >
        {this.state.error1}
      </SweetAlert>
    );

    this.setState({
      alert: getAlert(),
    });
    //  console.log("alert", this.state.alert);
  }

  showResponse() {
    const getAlert = () => (
      <SweetAlert
        success
        title="Mesazh"
        closeOnClickOutside={false}
        onConfirm={() => this.hideAlert()}
        onCancel={() => this.hideAlert()}
        showCancel
      >
        {this.state.error1}
      </SweetAlert>
    );

    this.setState({
      alert: getAlert(),
    });
  
  }

  handleClick = (e) => {
    
    const req = {
      Korrier: this.state.Korrier.label,
      Data: moment(this.state.Data1).format("MM/DD/YYYY"),
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),
       username: this.state.username,
    };
    this.setState({ loading: true }, () => {
      axios
        .post(window.UserP.url + "POD/PrintoManifestKorrier", req)
        .then((response) => {
        
          this.setState({
            loading: false,
            posts: response.data,
          });
          //this.showResponse();
          
          
          this.printfunction(this.state.posts);
      
          //   } else {
          //     this.setState({
          //       loading: false,
          //       error1: searchresults.ResultMessage,
          //     });

          //     console.log("reatcttable", this.state.error1, this.state.alert);
          //     this.showErrors();
        });
      //     .catch((error) => {
      //       this.setState({
      //         loading: false,
      //         error1: "Ju lutem kontaktoni departamentin e IT!",
      //       });
      //       this.showErrors();
      //     });
    });
  };

  render() {
    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.state.loading ? (
              <LoadingSpinner />
            ) : (
              <div className="Form">
                <div className="card card-body bg-light col-md-5 mt-4">
                  <label className="">Agjensia</label>
                  <input
                    className="form-control "
                    value={this.state.AgjensiaBurim}
                    type="text"
                    //   onChange={e => this.handleInputChange(e, "Agjensi")}
                    disabled={this.state.txtAgjensi}
                  />
                </div>
                <div className="card card-body bg-light col-md-5 mt-4">
                  <label className="">Korrieri</label>
                  <Select
                    onChange={this.onChangeFunc("Korrier")}
                    options={convertToDropDown(this.state.data2)}
                    //  defaultValue={{ value: "True", label: "Te Gjitha" }}
                    value={this.state.Korrier}
                  />
                </div>
        
                <div className="card card-body bg-light col-md-5 mt-4">
                  <label className="">Data</label>
                  <DatePicker
                    locale="en-NZ"
                    onChange={this.handleChange}
                    value={this.state.Data1}
                    name="Data1"
                    dateFormat="Pp"
                  />
                </div>
                <div className="col-md-4 ">
                  <button
                    className="btn btn-primary "
                    onClick={() => this.handleClick()}
                  >
                    Printo
                  </button>

                  <button className="btn btn-primary float-right ">
                    Pastro
                  </button>
                </div>
              </div>
            )}
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default PrintoManifestKorrieri;
